<template>
  <div class="chatBody">
      <MessageTip
        v-for="(message, index) in messages"
        :index="index"
        :question="message.question"
        :answer="message.answer"
        :key="message.id"
        @personTypeChange="onPersonTypeChange"
      />

      <MessageLimit v-if="wsStatus === 'limit_exceeded'"/>
  </div>
</template>

<script>
import MessageTip from '../elements/MessageTip'
import MessageLimit from '../elements/MessageLimit'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Body',
  components: {
    MessageTip,
    MessageLimit
  },
  props: {
    messages: {
      type: Array
    }
  },
  computed: {
    ...mapGetters({
      wsStatus: 'messages/getWsStatus'
    })
  },
  mounted () {
    setTimeout(() => {
      this.welcomeMessage()
    }, 600)
    this.scrollToEnd()
  },
  updated () {
    this.scrollToEnd()
  },
  methods: {
    ...mapActions({
      welcomeMessage: 'messages/welcomeMessage'
    }),
    scrollToEnd () {
      const chatBody = document.querySelector('.chatBody')
      chatBody.scrollTop = chatBody.scrollHeight
    },
    onPersonTypeChange (personType) {
      this.$emit('personTypeChange', personType)
    }
  }
}
</script>

<style scoped lang="scss">
.chatBody {
  padding: 10px 15px 0 15px;
   height: 350px;
   overflow: auto;
}
</style>
